import { OFFieldApi } from '../../../../generated/api/oFFieldApi.js';
import { OpenFormGridBlock, OpenFormGridCol } from '../../OpenFormComponents/OpenFormGrid.js';
import { OpenFormQuestionInput } from './OpenFormQuestionInput.js';
import { type SubscriptionReferences } from '../../OpenFormAnswers.js';
import { setValueOptions } from '../../OpenFormHooks/useOpenFormMethods.js';
import { subscriptionReferenceMsg, subscriptionServiceReferencesMsg, t } from '../../../../common/i18n/index.js';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';

/* eslint-disable @typescript-eslint/naming-convention */
export const OpenFormQuestionSubscriptionReferences = ({
  disabled,
  required,
  label,
  name,
  references: { Reference_Id_1__c = '', Reference_Id_2__c = '', Reference_Id_3__c = '', Reference_Id_4__c = '' } = {},
}: {
  disabled: boolean;
  required: boolean;
  label: string;
  name: string;
  references?: SubscriptionReferences;
}) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue(
      `${name}.subscriptionReferences`,
      {
        Reference_Id_1__c: Reference_Id_1__c,
        Reference_Id_2__c: Reference_Id_1__c && Reference_Id_2__c,
        Reference_Id_3__c: Reference_Id_2__c && Reference_Id_3__c,
        Reference_Id_4__c: Reference_Id_3__c && Reference_Id_4__c,
      },
      setValueOptions
    );
    !Reference_Id_1__c && setValue(name, undefined);
  }, [name, Reference_Id_1__c, Reference_Id_2__c, Reference_Id_3__c, Reference_Id_4__c, setValue]);

  return (
    <OpenFormGridBlock colWidth={6} className="of-openform__view__choices__narrow" justifyCenterOuter={true}>
      <OpenFormGridCol className={classNames({ ['label--mandatory']: required })}>
        <h4>{label || t.AQA9(subscriptionServiceReferencesMsg)}</h4>
      </OpenFormGridCol>
      <OpenFormQuestionInput
        label={`${t.ZLAU(subscriptionReferenceMsg)} 1`}
        name={`${name}.subscriptionReferences.${OFFieldApi.Reference_Id_1__c}`}
        disabled={disabled}
        required={false}
        maxLength={40}
        wrapGridRow={false}
        type="field"
      />
      <OpenFormQuestionInput
        label={`${t.ZLAU(subscriptionReferenceMsg)} 2`}
        name={`${name}.subscriptionReferences.${OFFieldApi.Reference_Id_2__c}`}
        disabled={disabled || !Reference_Id_1__c}
        required={false}
        maxLength={40}
        wrapGridRow={false}
        type="field"
      />
      <OpenFormQuestionInput
        label={`${t.ZLAU(subscriptionReferenceMsg)} 3`}
        name={`${name}.subscriptionReferences.${OFFieldApi.Reference_Id_3__c}`}
        disabled={disabled || !Reference_Id_2__c}
        required={false}
        maxLength={40}
        wrapGridRow={false}
        type="field"
      />
      <OpenFormQuestionInput
        label={`${t.ZLAU(subscriptionReferenceMsg)} 4`}
        name={`${name}.subscriptionReferences.${OFFieldApi.Reference_Id_4__c}`}
        disabled={disabled || !Reference_Id_3__c}
        required={false}
        maxLength={40}
        wrapGridRow={false}
        type="field"
      />
    </OpenFormGridBlock>
  );
};
